import { render, staticRenderFns } from "./CompanyConfigForm.vue?vue&type=template&id=235fc45f&scoped=true&"
import script from "./CompanyConfigForm.vue?vue&type=script&lang=js&"
export * from "./CompanyConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyConfigForm.vue?vue&type=style&index=0&id=235fc45f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235fc45f",
  null
  
)

export default component.exports